import { useEffect } from "react";

const setMeta = (attr, key, content) => {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

export default function Seo({ title, description, image, jsonLd }) {
  useEffect(() => {
    const full = title ? `${title} | SoloRentaPC` : "SoloRentaPC | Alquileres de largo plazo en Punta Cana";
    document.title = full;
    setMeta("property", "og:title", full);
    if (description) {
      setMeta("name", "description", description);
      setMeta("property", "og:description", description);
    }
    if (image) setMeta("property", "og:image", image);
    let link = document.head.querySelector('link[rel="canonical"]');
    if (link) link.setAttribute("href", window.location.origin + window.location.pathname);
    let script;
    if (jsonLd) {
      script = document.createElement("script");
      script.type = "application/ld+json";
      script.text = JSON.stringify(jsonLd);
      document.head.appendChild(script);
    }
    return () => { if (script) script.remove(); };
  }, [title, description, image, jsonLd]);
  return null;
}
